export const leads = [
  { path: 'created', title: 'Creación', icon: 'mdi-calendar-blank-outline' },
  { path: 'forwarder.name', title: 'Derivador', icon: 'mdi-account' },
  { path: 'channel.description', title: 'Canal', icon: '' },
  { path: 'sale.bonus', title: 'Bono', icon: 'mdi-currency-usd' },
  { path: 'sale.auto.discount', title: 'Descuento', icon: 'mdi-currency-usd' },
  { path: 'closingReason.description', title: 'Motivo de cierre', icon: 'mdi-close-circle-outline' },
]
